import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { PaperBox } from "../../../../components/Layout/PaperBox";
import { IPublicoFazendaDetalhe } from "../../../../types/api/cadastros/detalhar-publico";
import moment from "moment";
import DisplayNotFoundInfo from "../../../../components/DisplayNotFindInfo";

export default function CardFazendas({
    fazendas
}: CardFazendasProps) {

    return (
        <PaperBox title="Fazendas">
            {
                fazendas.length <= 0 &&
                <DisplayNotFoundInfo label="Nenhuma fazenda encontrada" />
            }
            {
                fazendas.length > 0 &&
                <TableContainer sx={{ maxHeight: 400 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                {headers.map((item, index) => {
                                    return (
                                        <TableCell key={index} align={item.numeric ? 'right' : 'left'} sx={{ minWidth: item.width }}>
                                            <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                fazendas.map((fazenda, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={{ paddingX: 2 }}>
                                                {`${fazenda.apelido} - ${fazenda.nome}`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {`${fazenda.cidade} - ${fazenda.estado}`}
                                            </TableCell>
                                            <TableCell sx={{ paddingX: 2 }} align="right">
                                                {moment(fazenda.data_manutencao).format('DD/MM/YYYY')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </PaperBox>
    )
}

interface CardFazendasProps {
    fazendas: IPublicoFazendaDetalhe[];
}

const headers = [
    {
        label: "Nome",
        numeric: false,
        width: '100%'
    },
    {
        label: "Cidade",
        numeric: false,
        width: '100%'
    },
    {
        label: "Data manutenção",
        numeric: false,
        width: '100%'
    }
]
